// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
import type { FirewallRoutingMetadata } from "./types";

const FIREWALL_ROUTING_METADATA_LOADERS: Readonly<
  Record<string, () => Promise<FirewallRoutingMetadata>>
> = Object.assign(Object.create(null), {
  ["adzuna"]: async () => {
    return (await import("./routing-details/adzuna.generated"))["firewallRoutingMetadata"];
  },
  ["agentmail"]: async () => {
    return (await import("./routing-details/agentmail.generated"))["firewallRoutingMetadata"];
  },
  ["agora"]: async () => {
    return (await import("./routing-details/agora.generated"))["firewallRoutingMetadata"];
  },
  ["ahrefs"]: async () => {
    return (await import("./routing-details/ahrefs.generated"))["firewallRoutingMetadata"];
  },
  ["airtable"]: async () => {
    return (await import("./routing-details/airtable.generated"))["firewallRoutingMetadata"];
  },
  ["alchemy"]: async () => {
    return (await import("./routing-details/alchemy.generated"))["firewallRoutingMetadata"];
  },
  ["altium-365"]: async () => {
    return (await import("./routing-details/altium-365.generated"))["firewallRoutingMetadata"];
  },
  ["amadeus"]: async () => {
    return (await import("./routing-details/amadeus.generated"))["firewallRoutingMetadata"];
  },
  ["amplitude"]: async () => {
    return (await import("./routing-details/amplitude.generated"))["firewallRoutingMetadata"];
  },
  ["anthropic-managed-agents"]: async () => {
    return (await import("./routing-details/anthropic-managed-agents.generated"))["firewallRoutingMetadata"];
  },
  ["apify"]: async () => {
    return (await import("./routing-details/apify.generated"))["firewallRoutingMetadata"];
  },
  ["apollo"]: async () => {
    return (await import("./routing-details/apollo.generated"))["firewallRoutingMetadata"];
  },
  ["asana"]: async () => {
    return (await import("./routing-details/asana.generated"))["firewallRoutingMetadata"];
  },
  ["ashby"]: async () => {
    return (await import("./routing-details/ashby.generated"))["firewallRoutingMetadata"];
  },
  ["atlascloud"]: async () => {
    return (await import("./routing-details/atlascloud.generated"))["firewallRoutingMetadata"];
  },
  ["atlassian"]: async () => {
    return (await import("./routing-details/atlassian.generated"))["firewallRoutingMetadata"];
  },
  ["attio"]: async () => {
    return (await import("./routing-details/attio.generated"))["firewallRoutingMetadata"];
  },
  ["aviationstack"]: async () => {
    return (await import("./routing-details/aviationstack.generated"))["firewallRoutingMetadata"];
  },
  ["aws"]: async () => {
    return (await import("./routing-details/aws.generated"))["firewallRoutingMetadata"];
  },
  ["axiom"]: async () => {
    return (await import("./routing-details/axiom.generated"))["firewallRoutingMetadata"];
  },
  ["base44"]: async () => {
    return (await import("./routing-details/base44.generated"))["firewallRoutingMetadata"];
  },
  ["bentoml"]: async () => {
    return (await import("./routing-details/bentoml.generated"))["firewallRoutingMetadata"];
  },
  ["bfl"]: async () => {
    return (await import("./routing-details/bfl.generated"))["firewallRoutingMetadata"];
  },
  ["bitrefill"]: async () => {
    return (await import("./routing-details/bitrefill.generated"))["firewallRoutingMetadata"];
  },
  ["bitrix"]: async () => {
    return (await import("./routing-details/bitrix.generated"))["firewallRoutingMetadata"];
  },
  ["bland"]: async () => {
    return (await import("./routing-details/bland.generated"))["firewallRoutingMetadata"];
  },
  ["box"]: async () => {
    return (await import("./routing-details/box.generated"))["firewallRoutingMetadata"];
  },
  ["brave-search"]: async () => {
    return (await import("./routing-details/brave-search.generated"))["firewallRoutingMetadata"];
  },
  ["brevo"]: async () => {
    return (await import("./routing-details/brevo.generated"))["firewallRoutingMetadata"];
  },
  ["brex"]: async () => {
    return (await import("./routing-details/brex.generated"))["firewallRoutingMetadata"];
  },
  ["bright-data"]: async () => {
    return (await import("./routing-details/bright-data.generated"))["firewallRoutingMetadata"];
  },
  ["browser-use"]: async () => {
    return (await import("./routing-details/browser-use.generated"))["firewallRoutingMetadata"];
  },
  ["browserbase"]: async () => {
    return (await import("./routing-details/browserbase.generated"))["firewallRoutingMetadata"];
  },
  ["browserless"]: async () => {
    return (await import("./routing-details/browserless.generated"))["firewallRoutingMetadata"];
  },
  ["browserstack"]: async () => {
    return (await import("./routing-details/browserstack.generated"))["firewallRoutingMetadata"];
  },
  ["bubblemaps"]: async () => {
    return (await import("./routing-details/bubblemaps.generated"))["firewallRoutingMetadata"];
  },
  ["buffer"]: async () => {
    return (await import("./routing-details/buffer.generated"))["firewallRoutingMetadata"];
  },
  ["builtwith"]: async () => {
    return (await import("./routing-details/builtwith.generated"))["firewallRoutingMetadata"];
  },
  ["cal-com"]: async () => {
    return (await import("./routing-details/cal-com.generated"))["firewallRoutingMetadata"];
  },
  ["calendly"]: async () => {
    return (await import("./routing-details/calendly.generated"))["firewallRoutingMetadata"];
  },
  ["canva"]: async () => {
    return (await import("./routing-details/canva.generated"))["firewallRoutingMetadata"];
  },
  ["chatwoot"]: async () => {
    return (await import("./routing-details/chatwoot.generated"))["firewallRoutingMetadata"];
  },
  ["checkr"]: async () => {
    return (await import("./routing-details/checkr.generated"))["firewallRoutingMetadata"];
  },
  ["clado"]: async () => {
    return (await import("./routing-details/clado.generated"))["firewallRoutingMetadata"];
  },
  ["clearbit"]: async () => {
    return (await import("./routing-details/clearbit.generated"))["firewallRoutingMetadata"];
  },
  ["clerk"]: async () => {
    return (await import("./routing-details/clerk.generated"))["firewallRoutingMetadata"];
  },
  ["clickup"]: async () => {
    return (await import("./routing-details/clickup.generated"))["firewallRoutingMetadata"];
  },
  ["close"]: async () => {
    return (await import("./routing-details/close.generated"))["firewallRoutingMetadata"];
  },
  ["cloudflare"]: async () => {
    return (await import("./routing-details/cloudflare.generated"))["firewallRoutingMetadata"];
  },
  ["coda"]: async () => {
    return (await import("./routing-details/coda.generated"))["firewallRoutingMetadata"];
  },
  ["coingecko"]: async () => {
    return (await import("./routing-details/coingecko.generated"))["firewallRoutingMetadata"];
  },
  ["coresignal"]: async () => {
    return (await import("./routing-details/coresignal.generated"))["firewallRoutingMetadata"];
  },
  ["cronlytic"]: async () => {
    return (await import("./routing-details/cronlytic.generated"))["firewallRoutingMetadata"];
  },
  ["crustdata"]: async () => {
    return (await import("./routing-details/crustdata.generated"))["firewallRoutingMetadata"];
  },
  ["cursor"]: async () => {
    return (await import("./routing-details/cursor.generated"))["firewallRoutingMetadata"];
  },
  ["customer-io"]: async () => {
    return (await import("./routing-details/customer-io.generated"))["firewallRoutingMetadata"];
  },
  ["daytona"]: async () => {
    return (await import("./routing-details/daytona.generated"))["firewallRoutingMetadata"];
  },
  ["db9"]: async () => {
    return (await import("./routing-details/db9.generated"))["firewallRoutingMetadata"];
  },
  ["deel"]: async () => {
    return (await import("./routing-details/deel.generated"))["firewallRoutingMetadata"];
  },
  ["deepseek"]: async () => {
    return (await import("./routing-details/deepseek.generated"))["firewallRoutingMetadata"];
  },
  ["defillama"]: async () => {
    return (await import("./routing-details/defillama.generated"))["firewallRoutingMetadata"];
  },
  ["devto"]: async () => {
    return (await import("./routing-details/devto.generated"))["firewallRoutingMetadata"];
  },
  ["diffbot"]: async () => {
    return (await import("./routing-details/diffbot.generated"))["firewallRoutingMetadata"];
  },
  ["dify"]: async () => {
    return (await import("./routing-details/dify.generated"))["firewallRoutingMetadata"];
  },
  ["discord"]: async () => {
    return (await import("./routing-details/discord.generated"))["firewallRoutingMetadata"];
  },
  ["discord-webhook"]: async () => {
    return (await import("./routing-details/discord-webhook.generated"))["firewallRoutingMetadata"];
  },
  ["docusign"]: async () => {
    return (await import("./routing-details/docusign.generated"))["firewallRoutingMetadata"];
  },
  ["doppler"]: async () => {
    return (await import("./routing-details/doppler.generated"))["firewallRoutingMetadata"];
  },
  ["doubao"]: async () => {
    return (await import("./routing-details/doubao.generated"))["firewallRoutingMetadata"];
  },
  ["drive9"]: async () => {
    return (await import("./routing-details/drive9.generated"))["firewallRoutingMetadata"];
  },
  ["dropbox"]: async () => {
    return (await import("./routing-details/dropbox.generated"))["firewallRoutingMetadata"];
  },
  ["dropbox-sign"]: async () => {
    return (await import("./routing-details/dropbox-sign.generated"))["firewallRoutingMetadata"];
  },
  ["duffel"]: async () => {
    return (await import("./routing-details/duffel.generated"))["firewallRoutingMetadata"];
  },
  ["e2b"]: async () => {
    return (await import("./routing-details/e2b.generated"))["firewallRoutingMetadata"];
  },
  ["elevenlabs"]: async () => {
    return (await import("./routing-details/elevenlabs.generated"))["firewallRoutingMetadata"];
  },
  ["etherscan"]: async () => {
    return (await import("./routing-details/etherscan.generated"))["firewallRoutingMetadata"];
  },
  ["etsy"]: async () => {
    return (await import("./routing-details/etsy.generated"))["firewallRoutingMetadata"];
  },
  ["exa"]: async () => {
    return (await import("./routing-details/exa.generated"))["firewallRoutingMetadata"];
  },
  ["explorium"]: async () => {
    return (await import("./routing-details/explorium.generated"))["firewallRoutingMetadata"];
  },
  ["faire"]: async () => {
    return (await import("./routing-details/faire.generated"))["firewallRoutingMetadata"];
  },
  ["fal"]: async () => {
    return (await import("./routing-details/fal.generated"))["firewallRoutingMetadata"];
  },
  ["figma"]: async () => {
    return (await import("./routing-details/figma.generated"))["firewallRoutingMetadata"];
  },
  ["firecrawl"]: async () => {
    return (await import("./routing-details/firecrawl.generated"))["firewallRoutingMetadata"];
  },
  ["fireflies"]: async () => {
    return (await import("./routing-details/fireflies.generated"))["firewallRoutingMetadata"];
  },
  ["flightaware"]: async () => {
    return (await import("./routing-details/flightaware.generated"))["firewallRoutingMetadata"];
  },
  ["freshdesk"]: async () => {
    return (await import("./routing-details/freshdesk.generated"))["firewallRoutingMetadata"];
  },
  ["gamma"]: async () => {
    return (await import("./routing-details/gamma.generated"))["firewallRoutingMetadata"];
  },
  ["garmin-connect"]: async () => {
    return (await import("./routing-details/garmin-connect.generated"))["firewallRoutingMetadata"];
  },
  ["gemini"]: async () => {
    return (await import("./routing-details/gemini.generated"))["firewallRoutingMetadata"];
  },
  ["github"]: async () => {
    return (await import("./routing-details/github.generated"))["firewallRoutingMetadata"];
  },
  ["gitlab"]: async () => {
    return (await import("./routing-details/gitlab.generated"))["firewallRoutingMetadata"];
  },
  ["gmail"]: async () => {
    return (await import("./routing-details/gmail.generated"))["firewallRoutingMetadata"];
  },
  ["gong"]: async () => {
    return (await import("./routing-details/gong.generated"))["firewallRoutingMetadata"];
  },
  ["google-ads"]: async () => {
    return (await import("./routing-details/google-ads.generated"))["firewallRoutingMetadata"];
  },
  ["google-analytics"]: async () => {
    return (await import("./routing-details/google-analytics.generated"))["firewallRoutingMetadata"];
  },
  ["google-calendar"]: async () => {
    return (await import("./routing-details/google-calendar.generated"))["firewallRoutingMetadata"];
  },
  ["google-cloud"]: async () => {
    return (await import("./routing-details/google-cloud.generated"))["firewallRoutingMetadata"];
  },
  ["google-docs"]: async () => {
    return (await import("./routing-details/google-docs.generated"))["firewallRoutingMetadata"];
  },
  ["google-drive"]: async () => {
    return (await import("./routing-details/google-drive.generated"))["firewallRoutingMetadata"];
  },
  ["google-maps"]: async () => {
    return (await import("./routing-details/google-maps.generated"))["firewallRoutingMetadata"];
  },
  ["google-meet"]: async () => {
    return (await import("./routing-details/google-meet.generated"))["firewallRoutingMetadata"];
  },
  ["google-search-console"]: async () => {
    return (await import("./routing-details/google-search-console.generated"))["firewallRoutingMetadata"];
  },
  ["google-sheets"]: async () => {
    return (await import("./routing-details/google-sheets.generated"))["firewallRoutingMetadata"];
  },
  ["granola"]: async () => {
    return (await import("./routing-details/granola.generated"))["firewallRoutingMetadata"];
  },
  ["greenhouse"]: async () => {
    return (await import("./routing-details/greenhouse.generated"))["firewallRoutingMetadata"];
  },
  ["groq"]: async () => {
    return (await import("./routing-details/groq.generated"))["firewallRoutingMetadata"];
  },
  ["gumroad"]: async () => {
    return (await import("./routing-details/gumroad.generated"))["firewallRoutingMetadata"];
  },
  ["helicone"]: async () => {
    return (await import("./routing-details/helicone.generated"))["firewallRoutingMetadata"];
  },
  ["heygen"]: async () => {
    return (await import("./routing-details/heygen.generated"))["firewallRoutingMetadata"];
  },
  ["hitem3d"]: async () => {
    return (await import("./routing-details/hitem3d.generated"))["firewallRoutingMetadata"];
  },
  ["honcho"]: async () => {
    return (await import("./routing-details/honcho.generated"))["firewallRoutingMetadata"];
  },
  ["htmlcsstoimage"]: async () => {
    return (await import("./routing-details/htmlcsstoimage.generated"))["firewallRoutingMetadata"];
  },
  ["hubspot"]: async () => {
    return (await import("./routing-details/hubspot.generated"))["firewallRoutingMetadata"];
  },
  ["hugging-face"]: async () => {
    return (await import("./routing-details/hugging-face.generated"))["firewallRoutingMetadata"];
  },
  ["hume"]: async () => {
    return (await import("./routing-details/hume.generated"))["firewallRoutingMetadata"];
  },
  ["hunter"]: async () => {
    return (await import("./routing-details/hunter.generated"))["firewallRoutingMetadata"];
  },
  ["imgur"]: async () => {
    return (await import("./routing-details/imgur.generated"))["firewallRoutingMetadata"];
  },
  ["infisical"]: async () => {
    return (await import("./routing-details/infisical.generated"))["firewallRoutingMetadata"];
  },
  ["insforge"]: async () => {
    return (await import("./routing-details/insforge.generated"))["firewallRoutingMetadata"];
  },
  ["instagram"]: async () => {
    return (await import("./routing-details/instagram.generated"))["firewallRoutingMetadata"];
  },
  ["instantly"]: async () => {
    return (await import("./routing-details/instantly.generated"))["firewallRoutingMetadata"];
  },
  ["intercom"]: async () => {
    return (await import("./routing-details/intercom.generated"))["firewallRoutingMetadata"];
  },
  ["intervals-icu"]: async () => {
    return (await import("./routing-details/intervals-icu.generated"))["firewallRoutingMetadata"];
  },
  ["ironclad"]: async () => {
    return (await import("./routing-details/ironclad.generated"))["firewallRoutingMetadata"];
  },
  ["jam"]: async () => {
    return (await import("./routing-details/jam.generated"))["firewallRoutingMetadata"];
  },
  ["jira"]: async () => {
    return (await import("./routing-details/jira.generated"))["firewallRoutingMetadata"];
  },
  ["jotform"]: async () => {
    return (await import("./routing-details/jotform.generated"))["firewallRoutingMetadata"];
  },
  ["klaviyo"]: async () => {
    return (await import("./routing-details/klaviyo.generated"))["firewallRoutingMetadata"];
  },
  ["kommo"]: async () => {
    return (await import("./routing-details/kommo.generated"))["firewallRoutingMetadata"];
  },
  ["langfuse"]: async () => {
    return (await import("./routing-details/langfuse.generated"))["firewallRoutingMetadata"];
  },
  ["langsmith"]: async () => {
    return (await import("./routing-details/langsmith.generated"))["firewallRoutingMetadata"];
  },
  ["lark"]: async () => {
    return (await import("./routing-details/lark.generated"))["firewallRoutingMetadata"];
  },
  ["line"]: async () => {
    return (await import("./routing-details/line.generated"))["firewallRoutingMetadata"];
  },
  ["linear"]: async () => {
    return (await import("./routing-details/linear.generated"))["firewallRoutingMetadata"];
  },
  ["loops"]: async () => {
    return (await import("./routing-details/loops.generated"))["firewallRoutingMetadata"];
  },
  ["luma"]: async () => {
    return (await import("./routing-details/luma.generated"))["firewallRoutingMetadata"];
  },
  ["luma-ai"]: async () => {
    return (await import("./routing-details/luma-ai.generated"))["firewallRoutingMetadata"];
  },
  ["mailchimp"]: async () => {
    return (await import("./routing-details/mailchimp.generated"))["firewallRoutingMetadata"];
  },
  ["mailsac"]: async () => {
    return (await import("./routing-details/mailsac.generated"))["firewallRoutingMetadata"];
  },
  ["make"]: async () => {
    return (await import("./routing-details/make.generated"))["firewallRoutingMetadata"];
  },
  ["manus"]: async () => {
    return (await import("./routing-details/manus.generated"))["firewallRoutingMetadata"];
  },
  ["mapbox"]: async () => {
    return (await import("./routing-details/mapbox.generated"))["firewallRoutingMetadata"];
  },
  ["maskdb"]: async () => {
    return (await import("./routing-details/maskdb.generated"))["firewallRoutingMetadata"];
  },
  ["massive"]: async () => {
    return (await import("./routing-details/massive.generated"))["firewallRoutingMetadata"];
  },
  ["mathpix"]: async () => {
    return (await import("./routing-details/mathpix.generated"))["firewallRoutingMetadata"];
  },
  ["mem0"]: async () => {
    return (await import("./routing-details/mem0.generated"))["firewallRoutingMetadata"];
  },
  ["mercury"]: async () => {
    return (await import("./routing-details/mercury.generated"))["firewallRoutingMetadata"];
  },
  ["meshy"]: async () => {
    return (await import("./routing-details/meshy.generated"))["firewallRoutingMetadata"];
  },
  ["meta-ads"]: async () => {
    return (await import("./routing-details/meta-ads.generated"))["firewallRoutingMetadata"];
  },
  ["metabase"]: async () => {
    return (await import("./routing-details/metabase.generated"))["firewallRoutingMetadata"];
  },
  ["microsoft-365"]: async () => {
    return (await import("./routing-details/microsoft-365.generated"))["firewallRoutingMetadata"];
  },
  ["minimax"]: async () => {
    return (await import("./routing-details/minimax.generated"))["firewallRoutingMetadata"];
  },
  ["miro"]: async () => {
    return (await import("./routing-details/miro.generated"))["firewallRoutingMetadata"];
  },
  ["mixpanel"]: async () => {
    return (await import("./routing-details/mixpanel.generated"))["firewallRoutingMetadata"];
  },
  ["modal"]: async () => {
    return (await import("./routing-details/modal.generated"))["firewallRoutingMetadata"];
  },
  ["monday"]: async () => {
    return (await import("./routing-details/monday.generated"))["firewallRoutingMetadata"];
  },
  ["moss"]: async () => {
    return (await import("./routing-details/moss.generated"))["firewallRoutingMetadata"];
  },
  ["msg9"]: async () => {
    return (await import("./routing-details/msg9.generated"))["firewallRoutingMetadata"];
  },
  ["n8n"]: async () => {
    return (await import("./routing-details/n8n.generated"))["firewallRoutingMetadata"];
  },
  ["neon"]: async () => {
    return (await import("./routing-details/neon.generated"))["firewallRoutingMetadata"];
  },
  ["netdata"]: async () => {
    return (await import("./routing-details/netdata.generated"))["firewallRoutingMetadata"];
  },
  ["notion"]: async () => {
    return (await import("./routing-details/notion.generated"))["firewallRoutingMetadata"];
  },
  ["novita"]: async () => {
    return (await import("./routing-details/novita.generated"))["firewallRoutingMetadata"];
  },
  ["nyne"]: async () => {
    return (await import("./routing-details/nyne.generated"))["firewallRoutingMetadata"];
  },
  ["onyx"]: async () => {
    return (await import("./routing-details/onyx.generated"))["firewallRoutingMetadata"];
  },
  ["openai"]: async () => {
    return (await import("./routing-details/openai.generated"))["firewallRoutingMetadata"];
  },
  ["openrouter"]: async () => {
    return (await import("./routing-details/openrouter.generated"))["firewallRoutingMetadata"];
  },
  ["openweather"]: async () => {
    return (await import("./routing-details/openweather.generated"))["firewallRoutingMetadata"];
  },
  ["outlook-calendar"]: async () => {
    return (await import("./routing-details/outlook-calendar.generated"))["firewallRoutingMetadata"];
  },
  ["outlook-mail"]: async () => {
    return (await import("./routing-details/outlook-mail.generated"))["firewallRoutingMetadata"];
  },
  ["pandadoc"]: async () => {
    return (await import("./routing-details/pandadoc.generated"))["firewallRoutingMetadata"];
  },
  ["parallel"]: async () => {
    return (await import("./routing-details/parallel.generated"))["firewallRoutingMetadata"];
  },
  ["pdf4me"]: async () => {
    return (await import("./routing-details/pdf4me.generated"))["firewallRoutingMetadata"];
  },
  ["pdfco"]: async () => {
    return (await import("./routing-details/pdfco.generated"))["firewallRoutingMetadata"];
  },
  ["pdforge"]: async () => {
    return (await import("./routing-details/pdforge.generated"))["firewallRoutingMetadata"];
  },
  ["people-data-labs"]: async () => {
    return (await import("./routing-details/people-data-labs.generated"))["firewallRoutingMetadata"];
  },
  ["perplexity"]: async () => {
    return (await import("./routing-details/perplexity.generated"))["firewallRoutingMetadata"];
  },
  ["pexels"]: async () => {
    return (await import("./routing-details/pexels.generated"))["firewallRoutingMetadata"];
  },
  ["pika"]: async () => {
    return (await import("./routing-details/pika.generated"))["firewallRoutingMetadata"];
  },
  ["pinecone"]: async () => {
    return (await import("./routing-details/pinecone.generated"))["firewallRoutingMetadata"];
  },
  ["pipedream"]: async () => {
    return (await import("./routing-details/pipedream.generated"))["firewallRoutingMetadata"];
  },
  ["pipedrive"]: async () => {
    return (await import("./routing-details/pipedrive.generated"))["firewallRoutingMetadata"];
  },
  ["plain"]: async () => {
    return (await import("./routing-details/plain.generated"))["firewallRoutingMetadata"];
  },
  ["plausible"]: async () => {
    return (await import("./routing-details/plausible.generated"))["firewallRoutingMetadata"];
  },
  ["playstation"]: async () => {
    return (await import("./routing-details/playstation.generated"))["firewallRoutingMetadata"];
  },
  ["podchaser"]: async () => {
    return (await import("./routing-details/podchaser.generated"))["firewallRoutingMetadata"];
  },
  ["porkbun"]: async () => {
    return (await import("./routing-details/porkbun.generated"))["firewallRoutingMetadata"];
  },
  ["posthog"]: async () => {
    return (await import("./routing-details/posthog.generated"))["firewallRoutingMetadata"];
  },
  ["printful"]: async () => {
    return (await import("./routing-details/printful.generated"))["firewallRoutingMetadata"];
  },
  ["prisma-postgres"]: async () => {
    return (await import("./routing-details/prisma-postgres.generated"))["firewallRoutingMetadata"];
  },
  ["productlane"]: async () => {
    return (await import("./routing-details/productlane.generated"))["firewallRoutingMetadata"];
  },
  ["profound"]: async () => {
    return (await import("./routing-details/profound.generated"))["firewallRoutingMetadata"];
  },
  ["pushinator"]: async () => {
    return (await import("./routing-details/pushinator.generated"))["firewallRoutingMetadata"];
  },
  ["qdrant"]: async () => {
    return (await import("./routing-details/qdrant.generated"))["firewallRoutingMetadata"];
  },
  ["qiita"]: async () => {
    return (await import("./routing-details/qiita.generated"))["firewallRoutingMetadata"];
  },
  ["quickbooks"]: async () => {
    return (await import("./routing-details/quickbooks.generated"))["firewallRoutingMetadata"];
  },
  ["railway"]: async () => {
    return (await import("./routing-details/railway.generated"))["firewallRoutingMetadata"];
  },
  ["railway-project"]: async () => {
    return (await import("./routing-details/railway-project.generated"))["firewallRoutingMetadata"];
  },
  ["reap"]: async () => {
    return (await import("./routing-details/reap.generated"))["firewallRoutingMetadata"];
  },
  ["recraft"]: async () => {
    return (await import("./routing-details/recraft.generated"))["firewallRoutingMetadata"];
  },
  ["reddit"]: async () => {
    return (await import("./routing-details/reddit.generated"))["firewallRoutingMetadata"];
  },
  ["reducto"]: async () => {
    return (await import("./routing-details/reducto.generated"))["firewallRoutingMetadata"];
  },
  ["render"]: async () => {
    return (await import("./routing-details/render.generated"))["firewallRoutingMetadata"];
  },
  ["rentcast"]: async () => {
    return (await import("./routing-details/rentcast.generated"))["firewallRoutingMetadata"];
  },
  ["replicate"]: async () => {
    return (await import("./routing-details/replicate.generated"))["firewallRoutingMetadata"];
  },
  ["reportei"]: async () => {
    return (await import("./routing-details/reportei.generated"))["firewallRoutingMetadata"];
  },
  ["resend"]: async () => {
    return (await import("./routing-details/resend.generated"))["firewallRoutingMetadata"];
  },
  ["revenuecat"]: async () => {
    return (await import("./routing-details/revenuecat.generated"))["firewallRoutingMetadata"];
  },
  ["runway"]: async () => {
    return (await import("./routing-details/runway.generated"))["firewallRoutingMetadata"];
  },
  ["salesforce"]: async () => {
    return (await import("./routing-details/salesforce.generated"))["firewallRoutingMetadata"];
  },
  ["scrapeninja"]: async () => {
    return (await import("./routing-details/scrapeninja.generated"))["firewallRoutingMetadata"];
  },
  ["segment"]: async () => {
    return (await import("./routing-details/segment.generated"))["firewallRoutingMetadata"];
  },
  ["semrush"]: async () => {
    return (await import("./routing-details/semrush.generated"))["firewallRoutingMetadata"];
  },
  ["sendgrid"]: async () => {
    return (await import("./routing-details/sendgrid.generated"))["firewallRoutingMetadata"];
  },
  ["sentry"]: async () => {
    return (await import("./routing-details/sentry.generated"))["firewallRoutingMetadata"];
  },
  ["serpapi"]: async () => {
    return (await import("./routing-details/serpapi.generated"))["firewallRoutingMetadata"];
  },
  ["servicenow"]: async () => {
    return (await import("./routing-details/servicenow.generated"))["firewallRoutingMetadata"];
  },
  ["shopify"]: async () => {
    return (await import("./routing-details/shopify.generated"))["firewallRoutingMetadata"];
  },
  ["shortio"]: async () => {
    return (await import("./routing-details/shortio.generated"))["firewallRoutingMetadata"];
  },
  ["similarweb"]: async () => {
    return (await import("./routing-details/similarweb.generated"))["firewallRoutingMetadata"];
  },
  ["slack"]: async () => {
    return (await import("./routing-details/slack.generated"))["firewallRoutingMetadata"];
  },
  ["slack-webhook"]: async () => {
    return (await import("./routing-details/slack-webhook.generated"))["firewallRoutingMetadata"];
  },
  ["slock"]: async () => {
    return (await import("./routing-details/slock.generated"))["firewallRoutingMetadata"];
  },
  ["snowflake"]: async () => {
    return (await import("./routing-details/snowflake.generated"))["firewallRoutingMetadata"];
  },
  ["sociavault"]: async () => {
    return (await import("./routing-details/sociavault.generated"))["firewallRoutingMetadata"];
  },
  ["sponge"]: async () => {
    return (await import("./routing-details/sponge.generated"))["firewallRoutingMetadata"];
  },
  ["spotify"]: async () => {
    return (await import("./routing-details/spotify.generated"))["firewallRoutingMetadata"];
  },
  ["sproutgigs"]: async () => {
    return (await import("./routing-details/sproutgigs.generated"))["firewallRoutingMetadata"];
  },
  ["square"]: async () => {
    return (await import("./routing-details/square.generated"))["firewallRoutingMetadata"];
  },
  ["stability-ai"]: async () => {
    return (await import("./routing-details/stability-ai.generated"))["firewallRoutingMetadata"];
  },
  ["steam"]: async () => {
    return (await import("./routing-details/steam.generated"))["firewallRoutingMetadata"];
  },
  ["strapi"]: async () => {
    return (await import("./routing-details/strapi.generated"))["firewallRoutingMetadata"];
  },
  ["strava"]: async () => {
    return (await import("./routing-details/strava.generated"))["firewallRoutingMetadata"];
  },
  ["streak"]: async () => {
    return (await import("./routing-details/streak.generated"))["firewallRoutingMetadata"];
  },
  ["stripe"]: async () => {
    return (await import("./routing-details/stripe.generated"))["firewallRoutingMetadata"];
  },
  ["supabase"]: async () => {
    return (await import("./routing-details/supabase.generated"))["firewallRoutingMetadata"];
  },
  ["supadata"]: async () => {
    return (await import("./routing-details/supadata.generated"))["firewallRoutingMetadata"];
  },
  ["supermemory"]: async () => {
    return (await import("./routing-details/supermemory.generated"))["firewallRoutingMetadata"];
  },
  ["tavily"]: async () => {
    return (await import("./routing-details/tavily.generated"))["firewallRoutingMetadata"];
  },
  ["test-oauth"]: async () => {
    return (await import("./routing-details/test-oauth.generated"))["firewallRoutingMetadata"];
  },
  ["testrail"]: async () => {
    return (await import("./routing-details/testrail.generated"))["firewallRoutingMetadata"];
  },
  ["ticketmaster"]: async () => {
    return (await import("./routing-details/ticketmaster.generated"))["firewallRoutingMetadata"];
  },
  ["tiktok-ads"]: async () => {
    return (await import("./routing-details/tiktok-ads.generated"))["firewallRoutingMetadata"];
  },
  ["tldv"]: async () => {
    return (await import("./routing-details/tldv.generated"))["firewallRoutingMetadata"];
  },
  ["todoist"]: async () => {
    return (await import("./routing-details/todoist.generated"))["firewallRoutingMetadata"];
  },
  ["together"]: async () => {
    return (await import("./routing-details/together.generated"))["firewallRoutingMetadata"];
  },
  ["tripo"]: async () => {
    return (await import("./routing-details/tripo.generated"))["firewallRoutingMetadata"];
  },
  ["twenty"]: async () => {
    return (await import("./routing-details/twenty.generated"))["firewallRoutingMetadata"];
  },
  ["twilio"]: async () => {
    return (await import("./routing-details/twilio.generated"))["firewallRoutingMetadata"];
  },
  ["typeform"]: async () => {
    return (await import("./routing-details/typeform.generated"))["firewallRoutingMetadata"];
  },
  ["v0"]: async () => {
    return (await import("./routing-details/v0.generated"))["firewallRoutingMetadata"];
  },
  ["vercel"]: async () => {
    return (await import("./routing-details/vercel.generated"))["firewallRoutingMetadata"];
  },
  ["wandb"]: async () => {
    return (await import("./routing-details/wandb.generated"))["firewallRoutingMetadata"];
  },
  ["webflow"]: async () => {
    return (await import("./routing-details/webflow.generated"))["firewallRoutingMetadata"];
  },
  ["weread"]: async () => {
    return (await import("./routing-details/weread.generated"))["firewallRoutingMetadata"];
  },
  ["whale-alert"]: async () => {
    return (await import("./routing-details/whale-alert.generated"))["firewallRoutingMetadata"];
  },
  ["wix"]: async () => {
    return (await import("./routing-details/wix.generated"))["firewallRoutingMetadata"];
  },
  ["workos"]: async () => {
    return (await import("./routing-details/workos.generated"))["firewallRoutingMetadata"];
  },
  ["wrike"]: async () => {
    return (await import("./routing-details/wrike.generated"))["firewallRoutingMetadata"];
  },
  ["x"]: async () => {
    return (await import("./routing-details/x.generated"))["firewallRoutingMetadata"];
  },
  ["xero"]: async () => {
    return (await import("./routing-details/xero.generated"))["firewallRoutingMetadata"];
  },
  ["youtube"]: async () => {
    return (await import("./routing-details/youtube.generated"))["firewallRoutingMetadata"];
  },
  ["zapier"]: async () => {
    return (await import("./routing-details/zapier.generated"))["firewallRoutingMetadata"];
  },
  ["zapsign"]: async () => {
    return (await import("./routing-details/zapsign.generated"))["firewallRoutingMetadata"];
  },
  ["zendesk"]: async () => {
    return (await import("./routing-details/zendesk.generated"))["firewallRoutingMetadata"];
  },
  ["zep"]: async () => {
    return (await import("./routing-details/zep.generated"))["firewallRoutingMetadata"];
  },
  ["zeptomail"]: async () => {
    return (await import("./routing-details/zeptomail.generated"))["firewallRoutingMetadata"];
  },
  ["zoom"]: async () => {
    return (await import("./routing-details/zoom.generated"))["firewallRoutingMetadata"];
  },
} satisfies Readonly<
  Record<string, () => Promise<FirewallRoutingMetadata>>
>);

export async function loadGeneratedFirewallRoutingMetadata(
  type: string,
): Promise<FirewallRoutingMetadata | null> {
  const load = FIREWALL_ROUTING_METADATA_LOADERS[type];
  if (!load) {
    return null;
  }
  return await load();
}
